import { render } from "./WecomView.vue?vue&type=template&id=17273b1c&ts=true"
import script from "./WecomView.vue?vue&type=script&lang=ts"
export * from "./WecomView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__